export class TimerService {
  private intervals: Map<number, NodeJS.Timeout> = new Map();
  private timeouts: Map<number, NodeJS.Timeout> = new Map();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimer(callback: any, eventID: number, time: number, isPeriodic: boolean) {
    const action = () => {
      callback.raiseTimeEvent(eventID);
    };
    if (isPeriodic) this.intervals.set(eventID, setInterval(action, time));
    else this.timeouts.set(eventID, setTimeout(action, time));
  }

  unsetTimer(callback, eventID: number) {
    const timeout = this.timeouts.get(eventID);
    if (timeout) {
      clearTimeout(timeout);
      this.timeouts.delete(eventID);
    }
    const interval = this.intervals.get(eventID);
    if (interval) {
      clearInterval(interval);
      this.intervals.delete(eventID);
    }
  }
}
